export enum EStatus {
  Unpublished = 1,
  Published = 2,
  Deleted = 3,
  Inactive = 4,
  Active = 5,
  All = 6,
}

export enum SiteRoles {
  Admin = 1,
  Designer = 2,
  BlogPosts = 3,
  Guest = 4,
  ECommerce = 5,
  Customer = 6,
  Marketing = 7,
  Author = 8
}

export enum Days {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export enum LoginType {
  Direct_login = 1,
  InDirect_login = 2,
  Portal_login = 3,
  Mobile_login = 4,
  External_login = 5
}
export enum Reason {
  Change_Password = 1,
  Forget_Password = 2,
  Expire_Password = 3
}
export enum TypeOfAssets {
  CSS = 1,
  JS = 2
}